import { FETCH_REPORT_CAP_REQUEST, FETCH_REPORT_CAP_SUCCESS, FETCH_REPORT_CAP_FAILURE } from './actions';

const initialState = {
    loading: false,
    data: null,
    error: null,
};

const reportCAPReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_REPORT_CAP_REQUEST:
            return { ...state, loading: true };
        case FETCH_REPORT_CAP_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case FETCH_REPORT_CAP_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default reportCAPReducer;
